/**
 * Minimal entry: runs before any app imports. ES modules execute all static imports
 * before the rest of the file — if those fail, body code never ran (why only the
 * index.html inline script appeared).
 */
console.log("[TPP] main.tsx — loading application bundle…");

void import("./mainApp")
  .then(() => {
    console.log("[TPP] mainApp.tsx finished initializing");
  })
  .catch((err: unknown) => {
    console.error(
      "[TPP] Failed to load or run mainApp.tsx — fix the error below (often a bad import or wrong dev server).",
      err,
    );
  });
